import { referralActionTypes, userActionTypes } from '../actions/types';
import { referralService } from '../services';
import _ from 'lodash';

const _refreshTokenOnFailure = (error, failureAction, pendingRefreshToken) => {
  if (error.error === 'jwt expired') {
    if (pendingRefreshToken) {
      return {
        type: userActionTypes.PENDING_REFRESH_TOKEN,
        error,
      };
    } else {
      return { type: userActionTypes.INVALID_TOKEN, error };
    }
  } else {
    return { type: failureAction, error };
  }
};

const getListOfReferred = (referralId, codes, boughtPlan) => {
  return (dispatch, getState) => {
    dispatch(request());

    referralService.findAllReferred(referralId, codes, boughtPlan).then(
      referredList => {
        dispatch(success(referredList));
      },
      error => {
        dispatch(
          _refreshTokenOnFailure(
            error,
            referralActionTypes.FETCH_FAILURE,
            getState().authentication.pendingRefreshingToken,
          ),
        );
      },
    );
  };

  function request() {
    return { type: referralActionTypes.FETCH_REQUEST };
  }
  function success(referredList) {
    return { type: referralActionTypes.FETCH_SUCCESS, referredList };
  }
};

const getAllReferrals = () => {
  return (dispatch, getState) => {
    dispatch(request());

    referralService.getAllReferrals().then(
      referralList => {
        dispatch(success(referralList));
      },
      error => {
        dispatch(
          _refreshTokenOnFailure(
            error,
            referralActionTypes.FETCH_FAILURE,
            getState().authentication.pendingRefreshingToken,
          ),
        );
      },
    );
  };

  function request() {
    return { type: referralActionTypes.FETCH_REQUEST };
  }
  function success(referralList) {
    return { type: referralActionTypes.FETCH_SUCCESS, referralList };
  }
}

const findReferral = referralId => {
  return (dispatch, getState) => {
    dispatch(request());

    referralService.findOne(referralId).then(
      referral => {
        dispatch(success(referral));
      },
      error => {
        dispatch(
          _refreshTokenOnFailure(
            error,
            referralActionTypes.FIND_FAILURE,
            getState().authentication.pendingRefreshingToken,
          ),
        );
      },
    );
  };

  function request() {
    return { type: referralActionTypes.FIND_REQUEST };
  }
  function success(referral) {
    return { type: referralActionTypes.FIND_SUCCESS, referral };
  }
}

const createReferral = referral => {
  return (dispatch, getState) => {
    dispatch(request());

    referralService.createReferral(referral).then(
      referral => {
        dispatch(success(referral));
      },
      error => {
        dispatch(
          _refreshTokenOnFailure(
            error,
            referralActionTypes.CREATE_FAILURE,
            getState().authentication.pendingRefreshingToken,
          ),
        );
      },
    );
  };

  function request() {
    return { type: referralActionTypes.CREATE_REQUEST };
  }
  function success(referral) {
    return { type: referralActionTypes.CREATE_SUCCESS, referral };
  }
}

const updateReferral = referral => {
  return (dispatch, getState) => {
    dispatch(request());

    referralService.updateReferral(referral).then(
      referral => {
        dispatch(success(referral));
      },
      error => {
        dispatch(
          _refreshTokenOnFailure(
            error,
            referralActionTypes.UPDATE_FAILURE,
            getState().authentication.pendingRefreshingToken,
          ),
        );
      },
    );
  };

  function request() {
    return { type: referralActionTypes.UPDATE_REQUEST };
  }
  function success(referral) {
    return { type: referralActionTypes.UPDATE_SUCCESS, referral };
  }
}

const addCode = (referralId, code) => {
  return (dispatch, getState) => {
    dispatch(request());
    const codeId = code.id;
    delete code.id;

    referralService.addCode(referralId, code).then(
      codes => {
        dispatch(success(codes));
      },
      error => {
        dispatch(
          _refreshTokenOnFailure(
            error,
            referralActionTypes.ADD_CODE_FAILURE,
            getState().authentication.pendingRefreshingToken,
          ),
        );
      },
    );
  };

  function request() {
    return { type: referralActionTypes.ADD_CODE_REQUEST };
  }
  function success(codes) {
    return { type: referralActionTypes.ADD_CODE_SUCCESS, codes };
  }
}

const updateCode = (referralId, code) => {
  return (dispatch, getState) => {
    dispatch(request());
    const codeId = code.id;
    delete code.id;

    referralService.updateCode(referralId, codeId, code).then(
      codes => {
        dispatch(success(codes));
      },
      error => {
        dispatch(
          _refreshTokenOnFailure(
            error,
            referralActionTypes.UPDATE_CODE_FAILURE,
            getState().authentication.pendingRefreshingToken,
          ),
        );
      },
    );
  };

  function request() {
    return { type: referralActionTypes.UPDATE_CODE_REQUEST };
  }
  function success(codes) {
    return { type: referralActionTypes.UPDATE_CODE_SUCCESS, codes };
  }
}

export const referralActions = {
  getListOfReferred,
  getAllReferrals,
  findReferral,
  createReferral,
  updateReferral,
  addCode,
  updateCode,
};
